import React, { useContext } from 'react';
import { useDialog } from 'dialog-provider-hooks';
import { useHistory } from 'react-router';
import AppTable from 'components/basic/AppTable';
import { TraitsCtx } from 'pages/TraitsPage';
import usePermissions from 'hooks/permissions-hooks';
import actions from 'roles-actions-permissions/actions';
import { useItems } from '../../../hooks/atoms/items-hook';
import CollectionKeys from '../../../hooks/molecules/collection-keys';

const tableColumns = [
  { id: 1, label: 'ID', field: 'id' },
  { id: 2, label: 'Name', field: 'name' },
  { id: 3, label: 'Covariance ID', field: 'covariance_id' },
  // { id: 3, label: 'Category', field: 'category' },
  // { id: 4, label: 'PRS', field: 'prs_id.name' },
];

const TraitsTable = () => {
  const { search } = useContext(TraitsCtx);
  const { hasPermissions } = usePermissions();
  const searchFilter = (row) => {
    return '' === search || Object.values(row).some((value) => {
      const textToSearch = value?.toString()?.toLowerCase();
      return textToSearch?.includes(search.toLowerCase());
    });
  };

  const history = useHistory();

  const { openDialog } = useDialog();

  const {
    items: traits,
    itemsLoading: traitsLoading,
    itemsError: traitsError,
    pagination,
    deleteItem,
  } = useItems(CollectionKeys.TRAITS);

  // event, id
  const handleViewAction = (event, id) => {
    history.push({
      pathname: '/traits',
      search: `?id=${ id }`,
    });
  };
  // event, id
  const handleEditAction = () => {
  };

  const openDeleteTraitDialog = (id) => {
    openDialog({
      title: 'Delete Trait?',
      body() {
        return (<p>Are you sure you want to delete the trait</p>);
      },
      onSubmit() {
        deleteItem(id);
      },
    });
  };

  // event, id
  const handleDelAction = (event, id) => {
    openDeleteTraitDialog(id);
  };

  if (traitsError) {
    return (
      <span>
        Error:
        {traitsError.message}
      </span>
    );
  }

  return (
    <AppTable
      columns={ tableColumns }
      paginationProps={ pagination }
      loading={ traitsLoading }
      data={ traits?.filter(searchFilter) }
      ViewProp={ { handleView: handleViewAction, disabledView: !hasPermissions(actions.VIEW_TRAIT) } }
      EditProp={ { handleEdit: handleEditAction, disabledEdit: !hasPermissions(actions.EDIT_TRAIT) } }
      DelProp={ { handleDelete: handleDelAction, disabledDelete: !hasPermissions(actions.DELETE_TRAIT) } }
    />
  );
};
export default TraitsTable;
